import api from '../client';

export const MeetingsService = {
  getMeetings: (includeArchived = false) => api.get('/meetings', { params: { include_archived: includeArchived } }),
  getMeetingById: (id) => api.get(`/meetings/${id}`),
  createMeeting: (data) => api.post('/meetings', data),
  updateMeeting: (id, data) => api.patch(`/meetings/${id}`, data),
  deleteMeeting: (id) => api.delete(`/meetings/${id}`),
  archiveMeeting: (id) => api.post(`/meetings/${id}/archive`),
  unarchiveMeeting: (id) => api.post(`/meetings/${id}/unarchive`),
  addAgenda: (id, data) => api.post(`/meetings/${id}/agenda`, data),
  deleteAgenda: (id, itemId) => api.delete(`/meetings/${id}/agenda/${itemId}`),
  updateNotes: (id, data) => api.patch(`/meetings/${id}/notes`, data),
  startMeeting: (id) => api.post(`/meetings/${id}/start`),
  endMeeting: (id) => api.post(`/meetings/${id}/end`),
  uploadRecording: (id, data, config) => api.post(`/meetings/${id}/upload-recording`, data, config),
  uploadAttachment: (id, data) => api.post(`/meetings/${id}/attachments`, data),
};
